import { render } from "./index.vue?vue&type=template&id=4bbc939a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4bbc939a&lang=less&scoped=true"

import exportComponent from "F:\\p_for_tw\\maomeng\\users\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbc939a"]])

export default __exports__